// Geolocalizacion
import { DEFAULT_MOCK_POLICY } from 'src/geolocation/mock-policy-flag'

/**
 * Arranca en el default (apagado). La cache no se lee aqui a proposito: en este punto todavia no se
 * sabe a que organizacion pertenece el usuario, y una politica cacheada solo es confiable si es de
 * la suya (ver readCachedMockPolicy). refreshMockPolicy la adopta en el boot y en el login, ya con
 * esa organizacion en la mano, y la aplica de inmediato, antes de esperar al server.
 */
const initialState = () => ({
  current: null,
  mockPolicy: DEFAULT_MOCK_POLICY
})

export default initialState
